'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchWebMainPageQuery } from '@module/queries/main/mainQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import BroadcastLayout from '@pc/components/broadcast/BroadcastLayout';
import BannerContainer from '@pc/components/hook-wrapper/BannerContainer';
import useMediaQuery from '@pc/hooks/responsive/useMediaQuery';
import getMainListLengthByScreenSize from '@pc/utils/main/getMainListLengthByScreenSize';
import dynamic from 'next/dynamic';
import { Suspense, useEffect } from 'react';
import LivePopularContainer from './section/LivePopularContainer';
import LiveRecommendContainer from './section/LiveRecommendContainer';
import NewBjContainer from './section/NewBjContainer';
const VModeContainer = dynamic(() => import('./vmode/VModeContainer'), {
  ssr: false
});
export function MainContainer() {
  const $ = _c(36);
  const {
    pushModal
  } = useModalStore();
  const {
    siteMode,
    isLogin
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: mainInfo,
    isLoading,
    isFetching,
    isFetched,
    refetch
  } = useFetchWebMainPageQuery(t0);
  const {
    currentScreenSize
  } = useMediaQuery();
  let t1;
  if ($[1] !== currentScreenSize) {
    t1 = getMainListLengthByScreenSize(currentScreenSize);
    $[1] = currentScreenSize;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const listLength = t1;
  let t2;
  if ($[3] !== pushModal) {
    t2 = () => {
      const {
        hash
      } = window.location;
      if (hash === "#store-heart") {
        pushModal({
          type: "STORE_MODAL",
          id: "MainContainer",
          options: {
            tab: "heart"
          }
        });
      } else {
        if (hash === "#store-item") {
          pushModal({
            type: "STORE_MODAL",
            id: "MainContainer",
            options: {
              tab: "item"
            }
          });
        }
      }
    };
    $[3] = pushModal;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (siteMode?.mode === "v" && !isLogin) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Suspense fallback={null}><VModeContainer /></Suspense>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== currentScreenSize || $[8] !== isFetched || $[9] !== isFetching || $[10] !== isLoading || $[11] !== listLength || $[12] !== mainInfo) {
    t4 = <BroadcastLayout><NewBjContainer data={mainInfo} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} currentScreenSize={currentScreenSize} listLength={listLength} /></BroadcastLayout>;
    $[7] = currentScreenSize;
    $[8] = isFetched;
    $[9] = isFetching;
    $[10] = isLoading;
    $[11] = listLength;
    $[12] = mainInfo;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== currentScreenSize || $[15] !== isFetched || $[16] !== isFetching || $[17] !== isLoading || $[18] !== listLength || $[19] !== mainInfo) {
    t5 = <BroadcastLayout><LivePopularContainer data={mainInfo} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} currentScreenSize={currentScreenSize} listLength={listLength} /></BroadcastLayout>;
    $[14] = currentScreenSize;
    $[15] = isFetched;
    $[16] = isFetching;
    $[17] = isLoading;
    $[18] = listLength;
    $[19] = mainInfo;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== refetch) {
    t6 = () => refetch();
    $[21] = refetch;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== currentScreenSize || $[24] !== isFetched || $[25] !== isFetching || $[26] !== isLoading || $[27] !== listLength || $[28] !== mainInfo || $[29] !== t6) {
    t7 = <BroadcastLayout><LiveRecommendContainer data={mainInfo} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} currentScreenSize={currentScreenSize} listLength={listLength} onRefresh={t6} /></BroadcastLayout>;
    $[23] = currentScreenSize;
    $[24] = isFetched;
    $[25] = isFetching;
    $[26] = isLoading;
    $[27] = listLength;
    $[28] = mainInfo;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BannerContainer />;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t4 || $[33] !== t5 || $[34] !== t7) {
    t9 = <div className="pt-10" data-testid="main-page">{t4}{t5}{t7}{t8}</div>;
    $[32] = t4;
    $[33] = t5;
    $[34] = t7;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
}